// extracted by mini-css-extract-plugin
module.exports = {"event-card":"EventCard_event-card__aEucW","event-card__title":"EventCard_event-card__title__XASqg"};